import React, { useEffect, useState } from "react";
import ProfileCard from "../../components/ProfileCard/index";
import { CONSTANTS } from "../../constants/Constants";
import { analyticsHandler } from "../../services/firebase/googleAnalytics";
import { useNavigate } from "react-router-dom";
import SearchBarAndMenu from "../../components/SearchAndMenuSection";
import { useGlobalContext } from "../../context/GlobalContext";
import CreateProfileModal from "../../components/CreateProfileModal";
import api from "../../services/api/api";
import Button from "../../components/Buttons";
import { usePagination } from "../../hooks/usePagination";
import Pagination from "../../components/Pagination";
import LoadSpinner from "../../components/LoadingSpinner";
import { useToastContext } from "../../context/ToastContext";
import Breadcrumb from "../../components/BreadCrumb";
import {
  getProfiles,
  addProfiles,
  getResourceTitles,
  UserDetail,
} from "../../services/api/profile";
import CustomizeModal from "../../components/CustomizeModal";

const Dashboard: React.FC = () => {
  const [profile, setProfile] = useState({
    name: "",
    title: "",
    displayName: "",
  });
  const { setProfilesList, profilesList, user, setUser, setIsModifyDashboardModalOpen, isModifyDashboardModalOpen, isLoading, setIsLoading } = useGlobalContext();
  const { showToast } = useToastContext();
  const [isMenuOpen, setIsMenuOpen] = useState<boolean>(false);
  const [isCreateProfileModalOpen, setIsCreateProfileModalOpen] =
    useState<boolean>(false);

  const [addingProfileError, setAddingProfileError] = useState<string>("");
  const [displayNameMessage, setDisplayNameMessage] = useState<{
    message: string;
    success: boolean;
  }>({ message: "", success: false });
  const [isBtnDisable, setIsBtnDisable] = useState<boolean>(true);
  const [pagination, setPagination] = useState({
    totalCount: 0,
    pageSize: 8,
    currentPage: 1,
  });
  const [filtersDropDown, setFiltersDropDown] = useState<
    { id: string; name: string }[]
  >([]);
  const [filters, setFilters] = useState<{
    query: string;
    title: string;
    status: string;
    minValue?: string;
    maxValue?: string;
  }>({
    query: "",
    title: "",
    status: "",
    minValue: "",
    maxValue: ""
  });
  const [isModalLoading, setIsModalLoading] = useState<boolean>(false);
  const { pages, hasPrevious, hasNext, previous, next, goToPage } =
    usePagination(pagination);
  const navigate = useNavigate();

  const fetchProfilesAndFilters = async (newFilters = {}) => {
    setIsLoading(true);
    try {
      if (!filtersDropDown.length) {
        const titles = await getResourceTitles();
        const dropdownData = titles.data.map((filter: string) => ({
          id: filter,
          name: filter,
        }));
        setFiltersDropDown(dropdownData);
      }

      const params = {
        pageNumber: pagination.currentPage.toString(),
        pageSize: pagination.pageSize.toString(),
        ...filters,
        ...newFilters,
      };
      const data = await getProfiles(params);
      setProfilesList(data?.data);
      setPagination(data?.pagination);
    } catch (error: any) {
      setProfilesList([]);
      console.error(error?.response?.data?.message);
    }
    setIsLoading(false);
  };

  const filtersHandler = (filterQuery: string, filterName: string) => {
    setPagination({ ...pagination, currentPage: 1 })
    if (filterName === "experience") {
      const updatedFilters = {
        ...filters,
        minValue: filterQuery.split(",")[0],
        maxValue: filterQuery.split(",")[1],
      };
      setFilters(updatedFilters);
      fetchProfilesAndFilters(updatedFilters);
    } else {
      const updatedFilters = { ...filters, [filterName]: filterQuery };
      setFilters(updatedFilters);
      if (filterName !== "query" || (filterQuery.length === 3 || filterQuery === "")) {
        fetchProfilesAndFilters(updatedFilters);
      }

    }
  };

  useEffect(() => {
    fetchProfilesAndFilters();
    // eslint-disable-next-line
  }, [pagination.currentPage, pagination.pageSize]);

  useEffect(() => {
    const fetchUserDetail = async () => {
      let userUpdate = await UserDetail(user?.user?.email)
      setUser({ ...user, user: userUpdate?.data?.data?.user })

    }
    fetchUserDetail()
    // eslint-disable-next-line
  }, [])
  const handleFormSubmit = async () => {
    try {
      let res = await addProfiles(profile);
      showToast(CONSTANTS.PROFILE_CREATED_SUCCESSFULLY, "success");
      setIsCreateProfileModalOpen(false);
      let updatedProfileList = [...profilesList];
      updatedProfileList.unshift(res?.data);
      setProfilesList(updatedProfileList);
      navigate(`/modify-profile/${res?.data.id}`);
    } catch (error) {
      setAddingProfileError(CONSTANTS.ERROR_ADDING_PROFILE);
      setProfile({
        name: "",
        title: "",
        displayName: "",
      });
    }
  };

  const viewAndModifyProfileHandler = (route: any) => {
    analyticsHandler("profile_click", { name: profile.name });
    navigate(route);
  };

  const modalHandler = (isOpen: boolean) => {
    setProfile({
      name: "",
      title: "",
      displayName: "",
    });
    setIsCreateProfileModalOpen(isOpen);
    setIsBtnDisable(true);
    setDisplayNameMessage({ message: "", success: false });
  };

  useEffect(() => {
    setIsBtnDisable(
      profile.name === "" || profile.displayName === "" || profile.title === ""
    );
  }, [profile]);

  const changeHandler = (e: Event | string, name?: string) => {
    if (typeof e !== "string") {
      const target = e.target as HTMLInputElement;
      setProfile({ ...profile, [target.name]: target.value });
    } else if (name) {
      setProfile({ ...profile, [name]: e });
    }
  };

  const displayNameHandler = async (
    eOrDisplayName: Event | string | undefined
  ) => {
    let displayName = "";

    // Check if the parameter is an event
    if (eOrDisplayName && typeof eOrDisplayName !== "string") {
      const target = eOrDisplayName.target as HTMLInputElement;
      displayName = target.value;
    } else if (typeof eOrDisplayName === "string") {
      displayName = eOrDisplayName;
    }

    if (displayName) {
      setIsModalLoading(true);
      const formattedDisplayName = displayName.replaceAll(" ", "");
      let res = await api.post("Resource/VerifyDisplayName", {
        displayName: formattedDisplayName,
      });

      setProfile({
        ...profile,
        displayName: res.data.data.replaceAll(" ", ""),
      });
      setDisplayNameMessage({
        message: res.data.message,
        success: res.data.success,
      });

      if (
        profile.name === "" ||
        !formattedDisplayName ||
        profile.title === ""
      ) {
        setIsBtnDisable(true);
      } else {
        setIsBtnDisable(false);
      }
      setIsModalLoading(false);
    }
  };

  return (
    <div className="min-h-screen m-auto layout-container">
      <Breadcrumb path={[{ name: CONSTANTS.DASHBOARD_TXT, url: "" }]} />

      <div className="flex items-center">
        <SearchBarAndMenu
          toggleMenu={() => setIsMenuOpen(!isMenuOpen)}
          isMenuOpen={isMenuOpen}
          filtersHandler={filtersHandler}
          filters={filters}
          filtersDropDown={filtersDropDown}
        />
        {user?.permissions?.AddResourceSummary && (
          <Button
            btn_label={CONSTANTS.CREATE_PROFILE}
            on_click_handler={() => modalHandler(true)}
            other_classes={"!w-44 !h-11 text-[12px] hidden md:block"}
          />
        )}
      </div>

      {/* Profile Cards */}
      {isLoading ? (
        <div className="min-h-80 flex items-center justify-center">
          <LoadSpinner />
        </div>
      ) : (
        <div>
          {profilesList.length > 0 ? (
            <div className="mt-4 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
              {profilesList.map((profile: any, index: number) => {
                return (
                  <ProfileCard
                    key={index}
                    {...profile}
                    onClick={viewAndModifyProfileHandler}
                    isModificationAllowed={user?.permissions?.UpdateResource}
                  />
                );
              })}
            </div>
          ) : (
            <div className="text-center content-center h-96">
              {filters.query || filters.status || filters.title || filters.minValue || filters.maxValue ? (
                <>{CONSTANTS.NO_RESULTS_FOUND_TXT}</>)
                : (
                  <>
                    <h1>{CONSTANTS.WELCOME_TALENTHUB_TXT}</h1>
                    <p>{CONSTANTS.NO_PROFILES_CREATED_TXT}</p>
                  </>
                )
              }
            </div>
          )}
        </div>
      )}
      <div className="container mx-auto p-4">
        {pages.length > 1 && (
          <Pagination
            pages={pages}
            currentPage={pagination.currentPage}
            hasPrevious={hasPrevious}
            hasNext={hasNext}
            onPrevious={() => {
              previous();
              setPagination((prev) => ({
                ...prev,
                currentPage: prev.currentPage - 1,
              }));
            }}
            onNext={() => {
              next();
              setPagination((prev) => ({
                ...prev,
                currentPage: prev.currentPage + 1,
              }));
            }}
            onPageClick={(page) => {
              goToPage(page);
              setPagination((prev) => ({ ...prev, currentPage: page }));
            }}
          />
        )}
      </div>
      {isCreateProfileModalOpen && (
        <CreateProfileModal
          change_handler={changeHandler}
          modal_handler={modalHandler}
          submit_handler={handleFormSubmit}
          first_input_label={CONSTANTS.NAME_TXT}
          displayNameHandler={displayNameHandler}
          first_input_value={profile.name}
          first_input_name={
            CONSTANTS.PAYLOAD_KEYS.CREATE_UPDATE_RESOURCE_KEYS.NAME
          }
          second_input_name={
            CONSTANTS.PAYLOAD_KEYS.CREATE_UPDATE_RESOURCE_KEYS.TITLE
          }
          second_input_label={CONSTANTS.TITLE_TXT}
          error={addingProfileError}
          displayNameMessage={displayNameMessage}
          is_btn_disable={isBtnDisable}
          isModalLoading={isModalLoading}
          titleOptions={filtersDropDown}
        />
      )}
      {isModifyDashboardModalOpen && <CustomizeModal
        setIsModifyDashboardModalOpen={() => setIsModifyDashboardModalOpen(!isModifyDashboardModalOpen)}
      />}
    </div>
  );
};

export default Dashboard;
